import React from "react";
import { CheckCircle2, XCircle, Clock, ShieldCheck } from "lucide-react";
import type { ConversationCuration } from "../../types";

interface ConversationReviewPanelProps {
  curation: ConversationCuration;
}

export const ConversationReviewPanel: React.FC<ConversationReviewPanelProps> = ({ curation }) => {
  const total = curation.good + curation.bad + curation.unreviewed;

  return (
    <div
      style={{
        background: "var(--bg-surface, #111827)",
        border: "1px solid var(--border-subtle, rgba(255,255,255,0.08))",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "var(--text-primary, #f9fafb)" }}>
            Curación
          </h3>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "var(--text-muted, #9ca3af)" }}>
            Calificación de calidad y revisión humana efectuada en el panel de WordPress (§5.8)
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "var(--text-muted)", fontSize: "12px" }}>
          <ShieldCheck size={16} color="#10b981" />
          <span>Solo lectura sincronizada</span>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "14px",
        }}
      >
        {/* Calidad Buena */}
        <div
          style={{
            padding: "14px",
            background: "rgba(16, 185, 129, 0.05)",
            border: "1px solid rgba(16, 185, 129, 0.2)",
            borderRadius: "6px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
            <CheckCircle2 size={16} color="#10b981" />
            <span style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.05em", color: "#10b981", fontWeight: 600 }}>
              Calidad buena
            </span>
          </div>
          <div style={{ fontSize: "24px", fontWeight: 700, color: "var(--text-primary, #f9fafb)" }}>
            {curation.good.toLocaleString("es-CL")}
          </div>
          <div style={{ fontSize: "12px", color: "var(--text-muted, #9ca3af)", marginTop: "2px" }}>
            {total > 0 ? ((curation.good / total) * 100).toFixed(1) : 0}% del período
          </div>
        </div>

        {/* Calidad Mala */}
        <div
          style={{
            padding: "14px",
            background: "rgba(239, 68, 68, 0.05)",
            border: "1px solid rgba(239, 68, 68, 0.2)",
            borderRadius: "6px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
            <XCircle size={16} color="#ef4444" />
            <span style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.05em", color: "#ef4444", fontWeight: 600 }}>
              Calidad mala
            </span>
          </div>
          <div style={{ fontSize: "24px", fontWeight: 700, color: "var(--text-primary, #f9fafb)" }}>
            {curation.bad.toLocaleString("es-CL")}
          </div>
          <div style={{ fontSize: "12px", color: "var(--text-muted, #9ca3af)", marginTop: "2px" }}>
            {total > 0 ? ((curation.bad / total) * 100).toFixed(1) : 0}% del período
          </div>
        </div>

        {/* Sin Revisar */}
        <div
          style={{
            padding: "14px",
            background: "rgba(255, 255, 255, 0.02)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            borderRadius: "6px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
            <Clock size={16} color="var(--text-muted)" />
            <span style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--text-muted)", fontWeight: 600 }}>
              Sin revisar
            </span>
          </div>
          <div style={{ fontSize: "24px", fontWeight: 700, color: "var(--text-primary, #f9fafb)" }}>
            {curation.unreviewed.toLocaleString("es-CL")}
          </div>
          <div style={{ fontSize: "12px", color: "var(--text-muted, #9ca3af)", marginTop: "2px" }}>
            {total > 0 ? ((curation.unreviewed / total) * 100).toFixed(1) : 0}% pendientes de curación
          </div>
        </div>
      </div>
    </div>
  );
};
